import { useCallback } from 'react';

import { useActiveForm } from '@/components/form/ActiveSwitch';
import { useAppAlert } from '@Components/AppAlert';
import FormWrapper from '@Components/form/Wrapper';
import { TokenProvider } from '@Modules/settings/views/token/store';
import { useGlobalAuthStore } from '@Stores/global/auth';

import Form from '../components/Form';
import Heading from '../components/Heading';
import { ProfileProvider, useProfileStore } from '../store';

const propTypes = {}

function MyProfileForm() {
  const { collection: { item, useLoad, useSubmit } } = useProfileStore()
  const { handleSuccess, handleError } = useAppAlert()
  const { auth: { currentSession, getCurrentSession } } = useGlobalAuthStore()
  const { active, setActive } = useActiveForm(item)
  const user = currentSession?.user

  const loadData = useLoad(user?.id)

  const handleSubmit = useSubmit()

  const handleSubmitAndRefresh = useCallback(async payload => {
    try {
      await handleSubmit({ ...payload, active })
      const message = payload.id ? 'edited' : 'created';
      handleSuccess('Success', `User ${message}.`)
      await getCurrentSession()
      await loadData()
    } catch {
      handleError('Error', `User was not saved.`)
    }
  }, [handleSubmit, loadData, handleSuccess, handleError, getCurrentSession, active])

  if (!item) return null

  return <>
    <FormWrapper title='My Profile'>
      <Heading data={item} active={active} onChangeActive={setActive} />
      <Form data={item} handleSubmit={handleSubmitAndRefresh} />
    </FormWrapper>
  </>
}

MyProfileForm.propTypes = propTypes
MyProfileForm.defaultProps = {}

export default function ProfileFormLayout() {
  return <TokenProvider>
    <ProfileProvider>
      <MyProfileForm />
    </ProfileProvider>
  </TokenProvider>
}

